// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"42588ebd","667":"7f353e14","977":"efc22e32"}[chunkId] + ".chunk.js";
};